import config from 'SRC/config/config.yaml'

export const genders = config.registrationForm.genders
